export default __webpack_public_path__ + "static/media/intro3.e6a3d6d6.png";